import { getSavedChartFilters, saveChartFilters } from 'serviceWorker/services/chartFilters';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { chartFiltersContract } from 'shared/domain/chartFilters/chartFiltersContract';

/** Answers saved chart filters requests of the page. */
export function serveChartFiltersRequests(): ChannelUnsubscribe {
  return channelServer.handle(chartFiltersContract, {
    getSaved: getSavedChartFilters,
    save: saveChartFilters,
  });
}
